import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import EditPost from "../../components/EditPost/EditPost";

const Edit = () => {
	return (
		<>
			<Navbar></Navbar>
			<EditPost></EditPost>
		</>
	);
};

export default Edit;
